import React from 'react';
import { useStateContext } from '@zambezi/caballo-vivo';
import style from './DateTimeWarning.module.css';
export default function DateTimeWarning() {
  return useStateContext().getIn(['brand', 'showTimeInUKNotice']) ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.container, " js-date-time-warning")
  }, "All dates and times displayed are UK time") : /*#__PURE__*/React.createElement("div", null);
}